/* @flow */

import * as React from 'react';
import { once } from 'lodash';

import AdminSchoolSisSyncHeader from 'admin/components/AdminSchoolSisSyncHeader';
import EventTracking from 'lib/EventTracking';
import Image from 'components/Image';

type Props = {
  orgUuid: string,
  status: string,
  subtext: React.Element,
};

export default class AdminSisSyncProcessingView extends React.Component<Props> {
  componentWillMount() {
    this.trackView();
  }

  trackView = once(() => {
    EventTracking.view('rostering.sis_dash.processing.viewed', {
      organization_uud: this.props.orgUuid,
    });
  });

  render() {
    this.trackView();

    return (
      <section className="AdminSisSyncProcessingView">
        <AdminSchoolSisSyncHeader subtext={this.props.subtext} status={this.props.status} />
        <Image src={require('assets/images/admin/AdminSisSyncProcessingView/banner.svg')} />
      </section>
    );
  }
}
